import { useQuery } from '@tanstack/react-query'
import { ApiClient } from '../api'

// useDashboard - polls /api/dashboard once a minute so the KPI numbers and
// live banner stay roughly fresh without a manual refresh. The polling
// interval is cheap (one query, four scalars + ~6 upcoming rows + maybe one
// live event lookup); if it starts to hurt at scale, fall back to a longer
// stale window + manual revalidate-on-focus.
export function useDashboard() {
  return useQuery({
    queryKey: ['dashboard'],
    queryFn: ApiClient.dashboard,
    refetchInterval: 60_000
  })
}

export function useWeather() {
  return useQuery({
    queryKey: ['weather'],
    queryFn: ApiClient.weather,
    staleTime: 30 * 60_000,
    refetchInterval: 60 * 60_000,
    retry: 1
  })
}
